var React = require('react');

function FacebookInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2.36571 16V8.69714H0V5.86286H2.36571V3.76C2.36571 1.32571 3.79429 0 5.88571 0C6.89143 0 7.74857 0.08 8 0.114286V2.66286H6.54857C5.41714 2.66286 5.18857 3.23429 5.18857 4.05714V5.87429H7.89714L7.55429 8.70857H5.18857V16H2.36571Z","fill":"#EAE3D9"}));
}

FacebookInline.defaultProps = {"width":"8","height":"16","viewBox":"0 0 8 16","fill":"none"};

module.exports = FacebookInline;

FacebookInline.default = FacebookInline;
